import React from 'react'
import Header from '../Header/Main'
import Breadcrumb from '../Breadcrumb/Main'
import AppDevelopment from '../MenserviceAppDevelopment/AppDevelopment'
import Footer from '../Footer/Main'

function Main() {
    return (
        <>
            <div className="page-wrapper">
                <Header />
                <Breadcrumb subtitle="Home" title="App Development" />
                <AppDevelopment />
                <Footer />
            </div>
        </>
    )
}

export default Main